<template>
  <h-frame type="right" v-model:defaultOpen="openState">
    <div class="rightCommunity">
      <div>
        <x-title>车辆信息</x-title>
        <div class="rightCar">
          <div class="carItem">
            <div class="carbg">{{ clzs }}</div>
            <div class="carFontsize">车辆总量</div>
          </div>
          <div class="carItem">
            <div class="carbg">{{ cwzs }}</div>
            <div class="carFontsize">车位总量</div>
          </div>
          <div class="carItem">
            <div class="carbg">
              {{ cwzs == 0 ? 0 : ((clzs / cwzs).toFixed(2) * 100).toFixed(2) }}%
            </div>
            <div class="carFontsize">车位利用率</div>
          </div>
        </div>
      </div>
      <div>
        <div class="yellowColor">月流量趋势</div>
        <rightEcarts></rightEcarts>
      </div>
      <div>
        <x-title>事件统计</x-title>
        <div class="rightEvent">
          <div class="eventTitle">
            <div class="eventTime">
              <span>时间</span>
              <span class="timeclass"
                ><el-date-picker
                  v-model="timesearchsjtj"
                  type="datetimerange"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  @change="changeTime('timesearchsjtj')"
                >
                </el-date-picker
              ></span>
              <span>
                <!-- <i class="iconfont icon-rili"></i> -->
                <i class="iconfont icon-paixu"></i>
              </span>
            </div>
            <div class="eventIcon"></div>
          </div>
          <div class="eventList">
            <div class="eventItem" v-for="item in sjtjList" :key="item.id">
              <div class="eventNmae">{{ item.name }}</div>
              <div class="eventNumber">{{ item.value }}</div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <x-title>告警统计</x-title>
        <div class="rightEvent">
          <div class="yellowColor">告警总数</div>
          <div class="eventTitle">
            <div class="eventTime">
              <span>时间</span>
              <span class="timeclass"
                ><el-date-picker
                  v-model="timesearchgjtj"
                  type="datetimerange"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  @change="changeTime('timesearchgjtj')"
                >
                </el-date-picker
              ></span>
              <span>
                <!-- <i class="iconfont icon-rili"></i> -->
                <i class="iconfont icon-paixu"></i>
              </span>
            </div>
            <div class="eventIcon"></div>
          </div>
          <div class="eventList">
            <div class="eventItem" v-for="item in jgtjList" :key="item.id">
              <div class="eventNmae">{{ item.name }}</div>
              <div class="eventNumber">{{ item.value }}</div>
            </div>
          </div>
        </div>
      </div>
      <!--  -->
    </div>
  </h-frame>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  inject,
  watchEffect,
  nextTick,
} from "vue";
import rightEcarts from "./rightEcarts.vue";
import {
  analyseparkTotalNum,
  carcount,
  eventregion,
  cluecountByRegion,
} from "@/api/dataAnalysis/carAnalysis.js";
export default defineComponent({
  name: "",
  components: {
    rightEcarts,
  },
  props: {
    // frame开关状态
    frameStatus: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, context) {
    const data = reactive({
      timesearchgjtj: "",
      timesearchsjtj: "",
      clzs: 0,
      cwzs: 0,
      sjtjList: [],
      jgtjList: [],
      openState: true,
    });
    const refData = toRefs(data);
    // const areaData = inject("areaData");
    const regionInfo = inject("region");
    watchEffect(() => {
      if (regionInfo.regionList) {
        nextTick(() => {
          const params = {
            regionIds: regionInfo.regionList.toString(),
          };
          cluecountByRegionAxios(params);
          eventregionAxios(params);
          analyseparkTotalNumAxios();
        });
      }
    });
    watchEffect(() => {
      context.emit("update:frameStatus", data.openState);
    });
    const changeTime = (time) => {
      if (time === "timesearchgjtj") {
        if (data[time]) {
          cluecountByRegionAxios({
            startDate: data[time][0],
            endDate: data[time][1],
          });
        } else {
          cluecountByRegionAxios({});
        }
      } else {
        if (data[time]) {
          eventregionAxios({
            startDate: data[time][0],
            endDate: data[time][1]
          });
        } else {
          eventregionAxios({});
        }
      }
      console.log(
        "🚀 ~ file: rightCommunity.vue ~ line 106 ~ changeTime ~ time",
        data[time]
      );
    };
    const analyseparkTotalNumAxios = async () => {
      const params = {
        regionIds: regionInfo.regionList.toString(),
      };
      const res = await analyseparkTotalNum(params);
      data.cwzs = res.data.value;
      const ress = await carcount(params);
      data.clzs = ress.data.value;
      console.log(res, 111111);
    };

    const eventregionAxios = async (params) => {
      const res = await eventregion(params);
      data.sjtjList = res.data;
    };
    const cluecountByRegionAxios = async (params) => {
      const res = await cluecountByRegion(params);
      data.jgtjList = res.data;
    };
    // cluecountByRegionAxios({});
    // eventregionAxios({});
    return {
      ...refData,
      changeTime,
    };
  },
});
</script>
<style lang="scss" scoped>
.rightCommunity {
  width: 100%;
  height: 100%;
  padding: 0 10px;
  padding-top: 10px;
  color: #fff;
  overflow: auto;
  display: grid;
  grid-template-rows: 20% 30% 25% 25%;
  .rightCar {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    margin: 15px 0;
    .carItem {
      display: flex;
      flex-direction: column;
      align-items: center;
      .carbg {
        width: 68px;
        height: 67px;
        margin-right: 10px;
        text-align: center;
        line-height: 67px;
        background-image: url("~@/assets/images/home/yuan.png");
        background-size: cover;
      }
      .carFontsize {
        line-height: 40px;
      }
    }
  }
  .yellowColor {
    width: 100%;
    text-align: center;
    color: #f3ce61;
    line-height: 40px;
  }
  .rightEvent {
    display: flex;
    flex-direction: column;
    line-height: 30px;
    font-size: 14px;
    margin: 15px 0;
    height: 70%;
    .yellowColor {
      text-align: left;
      line-height: 14px;
    }
    .eventTitle {
      width: 100%;
      line-height: 30px;
      display: flex;
      margin-top: 10px;
      border-radius: 4px;
      background: #074c98;
      padding: 0 10px;
      .eventTime {
        width: 100%;
        display: flex;
        justify-content: space-between;
      }
      .eventIcon {
      }
    }
    .eventList {
      width: 100%;
      display: flex;
      flex-direction: column;
      overflow: auto;
      .eventItem {
        display: flex;
        padding: 0 10px;
        border-bottom: 1px solid #335e90;
        justify-content: space-between;
      }
    }
  }
  .timeclass {
    width: 82%;
    display: flex;
    :deep(.el-input__inner) {
      width: 100%;
      background-color: #3573c7 !important;
      border: 1px solid #3573c7;
      &::placeholder {
        color: #fff;
      }
      &::-webkit-input-placeholder {
        /* WebKit browsers 适配谷歌 */
        color: #fff;
      }

      &:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 适配火狐 */
        color: #fff;
      }

      &::-moz-placeholder {
        /* Mozilla Firefox 19+ 适配火狐 */
        color: #fff;
      }

      &:-ms-input-placeholder {
        /* Internet Explorer 10+  适配ie*/
        color: #fff;
      }
    }
    :deep(input) {
      background-color: #3573c7 !important;
      border: 1px solid #3573c7;
      color: #fff;
    }
    :deep(.el-range-separator) {
      color: #fff !important;
    }
    :deep(.el-range__icon) {
      color: #fff !important;
    }
    :deep(.el-range-input) {
      &::placeholder {
        color: #fff;
      }
      &::-webkit-input-placeholder {
        /* WebKit browsers 适配谷歌 */
        color: #fff;
      }
    }
  }
}
</style>
